"use strict";var _interopRequireDefault = require("D:\\work\\svn\\\u5BB6\u7528\u540E\u53F0\\branches\\20240430-1.5.0\\node_modules\\@babel\\runtime/helpers/interopRequireDefault");Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0;require("regenerator-runtime/runtime");var _asyncToGenerator2 = _interopRequireDefault(require("D:\\work\\svn\\\u5BB6\u7528\u540E\u53F0\\branches\\20240430-1.5.0\\node_modules\\@babel\\runtime-corejs2/helpers/asyncToGenerator"));require("core-js/modules/es6.regexp.split");require("core-js/modules/es6.function.name");require("core-js/modules/web.dom.iterable");



























































































































































































































































































var _qrcodejs = _interopRequireDefault(require("qrcodejs2"));
var _mechanism = _interopRequireDefault(require("@/components/Cascader/mechanism.vue"));
var _category = _interopRequireDefault(require("@/components/Cascader/category.vue"));
var _aliOss = _interopRequireDefault(require("@/utils/aliOss"));
var _user = require("@/utils/user"); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = { components: { Mechanism: _mechanism.default, Category: _category.default }, data: function data() {return { showProduct: false, //展示产品密钥弹窗
      productInfo: '', //产品密钥信息
      tableData: [], // 列表数据
      droplist: [], droplist2: [], searchData: { code: '', brandId: '', netMethod: '', controlType: '', page: 1, // 当前页码
        rows: 10 // 页码条数
      }, pageData: { page: 1, rows: 10, total: 0, pages: 1 }, newadd: false, title: '新增', checkList: [], addData: { id: '', categoryId: '', brandId: '', name: '', code: '', regionalDeviceMappers: '', country: [], imageFile: '', imgUrl: '', insId: '', netMethod: '', controlType: '', wifiRules: '', bluetoothRules: '', h5Path: '', soundboxSupport: '0', runningCheckUnabled: '0', mqtt: '', kafka: '', kafkaTopic: '', deviceTypeCode: '', netTips: '', netImg: '', h5Type: '' }, defaultData: { id: '', categoryId: '', brandId: '', name: '', code: '', regionalDeviceMappers: '', country: [], imageFile: '', imgUrl: '', insId: '', netMethod: '', controlType: '', wifiRules: '', bluetoothRules: '', h5Path: '', soundboxSupport: false, runningCheckUnabled: false, mqtt: '', kafka: '', kafkaTopic: '', deviceTypeCode: '', netTips: '', netImg: '', h5Type: '' }, rules: { brandId: [{ required: true, message: '请选择品牌名称', trigger: 'change' }], categoryId: [{ required: true, message: '请选择品类名称', trigger: 'change' }], name: [{ required: true, message: '请输入营销型号', trigger: 'blur' }], code: [{ required: true, message: '请输入工厂型号', trigger: 'blur' }], regionalDeviceMappers: [{ required: true, message: '请选择服务区域', trigger: ['change'] }], insId: [{ required: true, message: '请选择机构名称', trigger: 'blur' }], imageFile: [{ required: true, message: '请上传图片', trigger: 'blur' }], netMethod: [{ required: true, message: '请选择配网方式', trigger: 'change' }], controlType: [{ required: true, message: '请选择操作方式', trigger: 'change' }] }, regionList: [], countryList: [] };}, filters: { delFlagFilter: function delFlagFilter(val) {if (val === '0') {return '未删除';} else if (val === '1') {return '已删除';} else {return val;}} }, mounted: function mounted() {var self = this;self.init();self.getdrop();self.getdrop2();self.fetchRegionList();self.fetchCountryList();}, computed: { regionalName: function regionalName() {return function (row) {var list = [];if (row.servicesRegionalList) {row.servicesRegionalList.forEach(function (e) {list.push(e.regionalName);});}return list.length ? list.join(',') : '暂无';};}, countryName: function countryName() {return function (row) {var list = [];if (row.countryRegionalRefs) {row.countryRegionalRefs.forEach(function (e) {list.push(e.countryRegionalName);});}return list.length ? list.join(',') : '暂无';};} }, methods: { checkPermission: _user.checkPermission, init: function init() {var self = this;self.getData('/api/faDeviceType', self.searchData, function (res) {self.tableData = res.list;self.pageData.page = res.pageNum;self.pageData.total = res.total;});}, /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 * 获取区域列表
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 */fetchRegionList: function fetchRegionList() {var _this = this;this.getData('/api/faServicesRegional/getAll', { page: 1, rows: 9999999 }, function (res) {_this.regionList = res.list;});}, /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * 获取国家地区列表
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               */fetchCountryList: function fetchCountryList() {var _this2 = this;this.getData('/api/faCountryRegional/getCountryRegional', { page: 1, rows: 9999999 }, function (res) {_this2.countryList = res.list;});}, resetFun: function resetFun() {// 重置
      this.searchData.code = '';this.searchData.brandId = '';this.searchData.netMethod = '';this.searchData.controlType = '';this.init();}, searchFun: function searchFun() {// 搜索事件
      this.searchData.page = 1;this.init();}, handleSizeChange: function handleSizeChange(val) {// 分页条数
      this.searchData.rows = val;this.searchData.page = 1;this.init();}, handleCurrentChange: function handleCurrentChange(val) {// 分页页码
      this.searchData.page = val;this.init();}, delMenu: function delMenu(item) {var self = this;self.$confirm('确定删除该记录吗？', '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }).then(function () {self.delData('/api/faDeviceType/' + item.id, {}, function (res) {self.$message({ message: '删除成功!', type: 'success' });self.searchData.page = 1;self.init();});}).catch(function () {});}, addFun: function addFun() {// 新增
      this.title = '新增';this.newimg = '';this.addData = JSON.parse(JSON.stringify(this.defaultData));this.newadd = true;}, closeRefund: function closeRefund(done) {// 重置新增列表
      this.$refs['addForm'].resetFields();done();this.onCencal();}, onSubmit: function onSubmit() {var self = this;self.$refs.addForm.validate(function (valid) {if (valid) {var paramData = new FormData();if (self.newimg) {paramData.append('imageFile', self.newimg, self.newimg.name);} else {paramData.append('imageFile', self.addData.imageFile);}var ins = self.addData.insId; // let insi
          // if (self.addData.insId.length === 1) {
          //   insi = ins
          // } else {
          //   insi = self.addData.insId.pop()
          // }
          if (self.addData.soundboxSupport == '0') {self.addData.soundboxSupport = false;} else if (self.addData.soundboxSupport == '1') {self.addData.soundboxSupport = true;}if (self.addData.runningCheckUnabled == '0') {self.addData.runningCheckUnabled = false;} else if (self.addData.runningCheckUnabled == '1') {self.addData.runningCheckUnabled = true;}var list = [];self.addData.regionalDeviceMappers.forEach(function (e) {list.push({ regionalId: e });});paramData.append('regionalDeviceJson', JSON.stringify(list));var countryList = [];self.addData.country.forEach(function (e) {countryList.push({ countryRegionalId: e });});paramData.append('countryRegionalJson', JSON.stringify(countryList));paramData.append('brandId', self.addData.brandId);paramData.append('categoryId', self.addData.categoryId);paramData.append('name', self.addData.name);paramData.append('code', self.addData.code);paramData.append('insId', ins);paramData.append('netMethod', self.addData.netMethod);paramData.append('controlType', self.addData.controlType);paramData.append('wifiRules', self.addData.wifiRules);paramData.append('bluetoothRules', self.addData.bluetoothRules);paramData.append('h5Path', self.addData.h5Path);
          paramData.append('soundboxSupport', self.addData.soundboxSupport);
          paramData.append('runningCheckUnabled', self.addData.runningCheckUnabled);
          self.postFormData('/api/faDeviceType', paramData, function (res) {
            self.$message({
              message: '添加成功!',
              type: 'success' });

            self.onCencal();
            self.searchData.page = 1;
            self.init();
          });
        } else {
          return false;
        }
      });
    },

    updateMenu: function updateMenu(item) {
      var self = this;
      self.title = '修改';
      self.getData('/api/faDeviceType/' + item.id, {}, function (res) {
        self.newimg = '';
        self.addData.id = res.id;
        self.addData.brandId = res.brandId;
        self.addData.categoryId = res.categoryId;
        self.addData.code = res.code;
        var list = [];
        res.servicesRegionalList && res.servicesRegionalList.forEach(function (e) {
          if (e) {
            list.push(e.id);
          }
        });
        self.addData.regionalDeviceMappers = list;
        var countryList = [];
        res.countryRegionalRefs && res.countryRegionalRefs.forEach(function (e) {
          if (e) {
            countryList.push(e.countryRegionalId);
          }
        });
        self.addData.country = countryList;
        self.addData.name = res.name;
        self.addData.imageFile = res.imgUrl;
        self.addData.insId = res.insId;
        // 配网引导
        self.addData.netMethod = res.netMethod;
        self.addData.controlType = res.controlType;
        self.addData.wifiRules = res.wifiRules;
        self.addData.bluetoothRules = res.bluetoothRules;
        self.addData.h5Path = res.h5Path;
        self.addData.netTips = res.netTips;
        self.addData.netImg = res.netImg;
        self.addData.h5Type = res.h5Type;
      });
      self.newadd = true;
    },
    onUpdate: function onUpdate(item) {
      var self = this;
      self.$refs.addForm.validate(function (valid) {
        if (valid) {
          var paramData = new FormData();
          if (self.newimg) {
            paramData.append('imageFile', self.newimg, self.newimg.name);
          } else {
            paramData.append('imageFile', self.addData.imageFile);
          }
          if (self.addData.soundboxSupport == '0') {
            self.addData.soundboxSupport = false;
          } else if (self.addData.soundboxSupport == '1') {
            self.addData.soundboxSupport = true;
          }
          if (self.addData.runningCheckUnabled == '0') {
            self.addData.runningCheckUnabled = false;
          } else if (self.addData.runningCheckUnabled == '1') {
            self.addData.runningCheckUnabled = true;
          }
          var list = [];
          self.addData.regionalDeviceMappers.forEach(function (e) {
            list.push({
              regionalId: e });

          });
          paramData.append('regionalDeviceJson', JSON.stringify(list));
          var countryList = [];
          self.addData.country.forEach(function (e) {
            countryList.push({
              countryRegionalId: e });

          });
          paramData.append('countryRegionalJson', JSON.stringify(countryList));
          var ins = self.addData.insId;
          paramData.append('id', self.addData.id);
          paramData.append('brandId', self.addData.brandId);
          paramData.append('categoryId', self.addData.categoryId);
          paramData.append('code', self.addData.code);
          paramData.append('name', self.addData.name);
          paramData.append('insId', ins);
          paramData.append('netMethod', self.addData.netMethod);
          paramData.append('controlType', self.addData.controlType);
          paramData.append('wifiRules', self.addData.wifiRules);
          paramData.append('bluetoothRules', self.addData.bluetoothRules);
          paramData.append('h5Path', self.addData.h5Path);
          paramData.append('soundboxSupport', self.addData.soundboxSupport);
          paramData.append('runningCheckUnabled', self.addData.runningCheckUnabled);
          self.postData('/api/faDeviceType/' + self.addData.id, paramData, function (res) {
            self.$message({
              message: '修改成功!',
              type: 'success' });

            self.searchData.page = 1;
            self.init();
            self.onCencal();
          });
        } else {
          return false;
        }
      });
    },
    networkMenu: function networkMenu(item) {
      var self = this;
      self.title = '配网引导';
      self.getData('/api/faDeviceType/' + item.id, {}, function (res) {
        self.newimg = '';
        self.addData.id = res.id;
        self.addData.brandId = res.brandId;
        self.addData.categoryId = res.categoryId;
        self.addData.code = res.code;
        self.addData.name = res.name;
        self.addData.imageFile = res.imgUrl;
        self.addData.insId = res.insId;
        self.addData.netMethod = res.netMethod;
        self.addData.controlType = res.controlType;
        self.addData.wifiRules = res.wifiRules;
        self.addData.bluetoothRules = res.bluetoothRules;
        self.addData.h5Path = res.h5Path;
        self.addData.netTips = res.netTips;
        self.addData.netImg = res.netImg;
        self.addData.h5Type = res.h5Type;
        if (self.addData.h5Type) {
          self.checkList = self.addData.h5Type.substr(0, self.addData.h5Type.length - 1).split(',');
        }
        if (res.soundboxSupport == false) {
          self.addData.soundboxSupport = '0';
        } else if (res.soundboxSupport == null) {
          self.addData.soundboxSupport = '0';
        } else if (res.soundboxSupport == true) {
          self.addData.soundboxSupport = 1;
        }
        if (res.runningCheckUnabled == false) {
          self.addData.runningCheckUnabled = '0';
        } else if (res.runningCheckUnabled == null) {
          self.addData.runningCheckUnabled = '0';
        } else if (res.runningCheckUnabled == true) {
          self.addData.runningCheckUnabled = 1;
        }
      });
      self.newadd = true;
    },
    /**
        * 产品密钥
        */
    checkProductKey: function checkProductKey(row) {var _this3 = this;
      this.getData("/api/faDeviceType/".concat(row.code, "/validate"), {}, function (res) {
        if (res) {
          _this3.productInfo = res;
          _this3.showProduct = true;
        } else {
          _this3.$message({
            type: 'error',
            message: '暂无产品密钥' });

        }
      });
    },

    /**
        * 复制产品密钥信息
        */
    onProductCopySuccess: function () {var _onProductCopySuccess = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {return regeneratorRuntime.wrap(function _callee$(_context) {while (1) {switch (_context.prev = _context.next) {case 0:
                this.$message({
                  type: 'success',
                  message: '复制成功' });case 1:case "end":return _context.stop();}}}, _callee, this);}));function onProductCopySuccess() {return _onProductCopySuccess.apply(this, arguments);}return onProductCopySuccess;}(),



    h5TypeChange: function h5TypeChange(val) {
      var self = this;
      self.addData.h5Type = '';
      val.map(function (item) {
        self.addData.h5Type += item + ',';
      });
      console.log('self.addData.h5Type:', self.addData.h5Type);
    },
    onNetwork: function onNetwork(item) {
      var self = this;
      self.$refs.addForm.validate(function (valid) {
        if (valid) {
          // var paramData = new FormData()
          if (self.addData.soundboxSupport == '0') {
            self.addData.soundboxSupport = false;
          } else if (self.addData.soundboxSupport == '1') {
            self.addData.soundboxSupport = true;
          }
          if (self.addData.runningCheckUnabled == '0') {
            self.addData.runningCheckUnabled = false;
          } else if (self.addData.runningCheckUnabled == '1') {
            self.addData.runningCheckUnabled = true;
          }
          var ins = self.addData.insId;
          // paramData.append('id', self.addData.id)
          // paramData.append('brandId', self.addData.brandId)
          // paramData.append('categoryId', self.addData.categoryId)
          // paramData.append('code', self.addData.code)
          // paramData.append('name', self.addData.name)
          // paramData.append('insId', ins)
          // paramData.append('netMethod', self.addData.netMethod)
          // paramData.append('controlType', self.addData.controlType)
          // paramData.append('wifiRules', self.addData.wifiRules)
          // paramData.append('bluetoothRules', self.addData.bluetoothRules)
          // paramData.append('h5Path', self.addData.h5Path)
          // paramData.append('soundboxSupport', self.addData.soundboxSupport)
          // paramData.append('runningCheckUnabled', self.addData.runningCheckUnabled)
          // paramData.append('netTips', self.addData.netTips)
          // paramData.append('netImg', self.addData.netImg)
          // paramData.append('h5Type', self.addData.h5Type)
          self.postData('/api/faDeviceType/network/' + self.addData.id, {
            id: self.addData.id,
            brandId: self.addData.brandId,
            categoryId: self.addData.categoryId,
            code: self.addData.code,
            name: self.addData.name,
            insId: ins,
            netMethod: self.addData.netMethod,
            controlType: self.addData.controlType,
            wifiRules: self.addData.wifiRules,
            bluetoothRules: self.addData.bluetoothRules,
            h5Path: self.addData.h5Path,
            soundboxSupport: self.addData.soundboxSupport,
            runningCheckUnabled: self.addData.runningCheckUnabled,
            netTips: self.addData.netTips,
            netImg: self.addData.netImg,
            h5Type: self.addData.h5Type },
          function (res) {
            self.$message({
              message: '提交成功!',
              type: 'success' });

            self.searchData.page = 1;
            self.init();
            self.onCencal();
          });
        } else {
          return false;
        }
      });
    },
    pushBtn: function pushBtn() {
      var self = this;
      self.postData('/api/devicePushSetting', {
        deviceTypeCode: self.addData.deviceTypeCode,
        mqtt: self.addData.mqtt,
        kafka: self.addData.kafka,
        kafkaTopic: self.addData.kafkaTopic },
      function (res) {
        self.$message({
          message: '推送成功!',
          type: 'success' });

        self.onCencal();
        self.init();
      });
    },
    onCencal: function onCencal() {
      this.newadd = false;
      this.$refs['addForm'].resetFields();
    },
    onCencal2: function onCencal2() {
      $('#dialog2').hide();
      // window.location.reload()
    },
    getdrop: function getdrop() {
      var self = this;
      self.getData('/api/faBrandInfo/list', {}, function (res) {
        self.droplist = res;
      });
    },
    getdrop2: function getdrop2() {
      var self = this;
      self.getData('/api/faDeviceType/getDownList', {}, function (res) {
        self.droplist2 = res;
      });
    },
    imgPreview: function imgPreview(file) {
      var self = this;
      // 看支持不支持FileReader
      if (!file || !window.FileReader) return;

      if (/^image/.test(file.type)) {
        // 创建一个reader
        var reader = new FileReader();
        // 将图片将转成 base64 格式
        reader.readAsDataURL(file);
        // 读取成功后的回调
        reader.onloadend = function () {
          self.addData.imageFile = this.result;
        };
      }
    },
    onfileChange: function onfileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.newimg = files[0];
      this.imgPreview(files[0]);
    },
    // 上传配网引导图
    uploadIcon: function uploadIcon(option) {
      var path = 'network/img';
      _aliOss.default.ossUploadFile(option, path);
    },
    onsuccessNotIcon: function onsuccessNotIcon(res) {
      var fileUrl = 'https://cdn-tech.cozzia.com.cn/' + res.name;
      this.addData.netImg = fileUrl;
      console.log('addData.imageFile:', this.addData.netImg);
    },
    changeMechanism: function changeMechanism(val) {
      this.addData.insId = val;
    },
    changeCategory: function changeCategory(val) {
      this.addData.categoryId = val;
    },
    onNameInput: function onNameInput(value) {
      this.$set(this.addData, 'name', value.trim());
    },
    onCodeInput: function onCodeInput(value) {
      this.$set(this.addData, 'code', value.trim());
    },
    lookView: function lookView(item) {// 查看弹窗
      this.title = ' 查看';
      $('#dialog2').show();
      this.addData.code = item.code;
      this.qrcode();
    },
    pushFun: function pushFun(item) {
      var self = this;
      self.title = '推送设置';
      self.addData.deviceTypeCode = item.code;
      self.getData('/api/devicePushSetting/code/' + item.code, {}, function (res) {
        if (res != null) {
          self.addData.deviceTypeCode = res.deviceTypeCode;
          self.addData.mqtt = res.mqtt;
          self.addData.kafka = res.kafka;
          self.addData.kafkaTopic = res.kafkaTopic;
        } else {
          self.addData.mqtt = '1';
          self.addData.kafka = '0';
        }
      });
      this.newadd = true;
    },
    qrcode: function qrcode(item) {
      console.log('item:', item);
      item = this.addData.code;
      document.getElementById('qrcode').innerHTML = '';
      new _qrcodejs.default('qrcode', {
        width: 200,
        height: 200, // 高度
        text: 'http://manual.cozzia.com.cn/index.html?type=' + item, // 二维码内容
        render: 'canvas' // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
        //			        background: 'red',
        //			        foreground: 'green',
      });
      //		      	downloadButton: true
    },
    downloadQrcode: function downloadQrcode() {
      var qrcode = document.getElementById('qrcode');
      var img = qrcode.getElementsByTagName('img')[0];
      var link = document.createElement('a');
      var url = img.getAttribute('src');
      link.setAttribute('href', url);
      link.setAttribute('download', this.addData.code + '.png');
      link.click();
      this.onCencal2();
    } } };exports.default = _default;